import ActivitySearch from "@/modules/activities/ActivitySearch.model";
import _ from "lodash";
import ActivityService from "@/core/services/activity.service";

let getDefaultTableData = () => {
  return {
    show: false,
    object_uuid: null,
    activities: [],
    excludeActivities: [],
    loading: false,
    pagination: {
      limit: 10,
      page: 1,
      total: 0,
    },
    searchModel: new ActivitySearch()
  }
}

export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      invoice: getDefaultTableData(),
      customer: getDefaultTableData(),
      auction: getDefaultTableData(),
      receipt: getDefaultTableData(),
      inventory: getDefaultTableData(),
      condition_report: getDefaultTableData(),
    }
  },
  actions: {
    showActivitiesModal({commit}) {
      commit('showActivitiesModal');
    },
    setActivitiesParams({commit}, {object, source, limit, excludeActivities}) {
      commit('setActivitiesParams', {object: _.cloneDeep(object), source, limit, excludeActivities});
    },
    hideActivitiesModal({commit}) {
      commit('hideActivitiesModal');
    },
    async getActivities({state, commit}, page = null) {
      let data = {}
      if (page) {
        state.tableData[state.tableSource].pagination.page = page;
      }
      data = {
        object_uuid: state.tableData[state.tableSource].object_uuid,
        model: state.tableSource,
        expand: 'created_by',
        ...state.tableData[state.tableSource].pagination
      }
      commit('updateActivitiesLoading', true);
      let response = await ActivityService.getActivities({...data, ...state.tableData[state.tableSource].searchModel.toJSON()});
      if (response.success) {
        commit('setActivities', {data: response.body});
      }
      commit('updateActivitiesLoading', false);
      return response;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new ActivitySearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    resetPaginationPage: ({commit}) => {
      commit('resetPaginationPage')
    }
  },
  mutations: {
    setActivitiesParams: (state, {object, source, limit, excludeActivities}) => {
      state.tableSource = source;
      state.tableData[state.tableSource].object_uuid = object.uuid;
      state.tableData[state.tableSource].excludeActivities = excludeActivities ? excludeActivities : state.tableData[state.tableSource].excludeActivities;
      state.tableData[state.tableSource].pagination.limit = limit ? limit : state.tableData[state.tableSource].pagination.limit;
    },
    showActivitiesModal(state) {
      state.tableData[state.tableSource].show = true;
    },
    hideActivitiesModal: state => {
      state.tableData[state.tableSource] = getDefaultTableData()
    },
    setActivities: (state, {data}) => {
      state.tableData[state.tableSource].activities = []
      state.tableData[state.tableSource].pagination.total = data.count;
      for (let activity of data.results) {
        if (!state.tableData[state.tableSource].excludeActivities.includes(activity.action)) {
          state.tableData[state.tableSource].activities.push(activity);
        }
      }
    },
    updateSearchModel: (state, searchModel) => {
      state.tableData[state.tableSource].searchModel = searchModel
    },
    resetPaginationPage: (state) => state.tableData[state.tableSource].pagination.page = 1,
    updateActivitiesLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
  }
}